import { version } from '../package.json';

const Version = version;

export default Version;
